(() => {
  if (window.normConsentPreferences) return;
  window.normConsentPreferences = true;
  const copy = {
    tr: {
      select: 'Geri almak istediğiniz en az bir ileti kanalını seçin.',
      email: 'Seçtiğiniz e-posta kanalı için geçerli bir e-posta adresi yazın.',
      phone: 'Seçtiğiniz SMS kanalı için geçerli bir cep telefonu numarası yazın.',
      sending: 'Talebiniz gönderiliyor…',
      received: 'Talebiniz alındı. Gerekli izin güncellemeleri işlenecek.',
      completed: 'Talebiniz tamamlandı; İYS aktarımı doğrulandı.',
      retry: 'Talebin kaydedildiğini şu anda doğrulayamıyoruz. Lütfen tekrar deneyin veya aşağıdaki destek adresini kullanın.',
      rate: 'Çok sayıda talep gönderildi. Lütfen biraz bekleyip tekrar deneyin.'
    },
    en: {
      select: 'Select at least one message channel to withdraw.',
      email: 'Enter a valid email address for the selected email channel.',
      phone: 'Enter a valid mobile number for the selected SMS channel.',
      sending: 'Sending your request…',
      received: 'Your request was received. Any required permission updates will be processed.',
      completed: 'Your request is complete; transfer to İYS was verified.',
      retry: 'We cannot currently confirm that the request was recorded. Please try again or use the support address below.',
      rate: 'Too many requests were sent. Please wait a little before trying again.'
    }
  };
  const normalisePhone = (value) => {
    let digits = value.trim().replace(/[\s().-]/g, '');
    if (digits.startsWith('00')) digits = '+' + digits.slice(2);
    if (!digits.startsWith('+')) {
      if (/^0\d{10}$/.test(digits)) digits = '+90' + digits.slice(1);
      else if (/^5\d{9}$/.test(digits)) digits = '+90' + digits;
      else if (/^90\d{10}$/.test(digits)) digits = '+' + digits;
      else return null;
    }
    return /^\+\d{10,15}$/.test(digits) ? digits : null;
  };
  const initialize = () => document.querySelectorAll('[data-consent-withdraw]').forEach((form) => {
    if (form.dataset.consentBound) return;
    form.dataset.consentBound = 'true';
    const text = copy[form.dataset.locale === 'en' ? 'en' : 'tr'];
    const status = form.querySelector('[data-consent-status]');
    const button = form.querySelector('button[type="submit"]');
    const channels = [...form.querySelectorAll('[data-consent-channel]')];
    const fields = channels.map((channel) => ({channel, input: form.querySelector('[data-consent-recipient="' + channel.value + '"]')}));
    const show = (message, error = false) => {
      status.textContent = message;
      status.hidden = false;
      status.classList.toggle('iprefs__msg--err', error);
      status.setAttribute('role', error ? 'alert' : 'status');
    };
    const sync = () => fields.forEach(({channel, input}) => {
      input.disabled = !channel.checked;
      input.required = channel.checked;
      input.setCustomValidity('');
    });
    channels.forEach((channel) => channel.addEventListener('change', sync));
    fields.forEach(({input}) => input.addEventListener('input', () => input.setCustomValidity('')));
    sync();
    const site = form.dataset.site;
    const enabled = Boolean(window.fetch && window.AbortController && form.dataset.textVersion === 'commercial-message-withdrawal-2026-10-06.1' && ['rosecandy', 'lacinia', 'herbaclean', 'melomypet'].includes(site));
    button.disabled = !enabled;
    if (!enabled) show(text.retry, true);
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!enabled || button.disabled) return;
      const selected = fields.filter(({channel}) => channel.checked);
      if (!selected.length) {
        show(text.select, true);
        channels[0].focus();
        return;
      }
      const body = {metinSurumu: form.dataset.textVersion};
      for (const {channel, input} of selected) {
        input.setCustomValidity('');
        if (channel.value === 'EPOSTA') {
          if (!input.value.trim() || !input.validity.valid) {
            input.setCustomValidity(text.email);
            input.reportValidity();
            show(text.email, true);
            return;
          }
          body.email = input.value.trim();
        } else {
          const phone = normalisePhone(input.value);
          if (!phone) {
            input.setCustomValidity(text.phone);
            input.reportValidity();
            show(text.phone, true);
            return;
          }
          body.telefon = phone;
        }
      }
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      fields.forEach(({channel, input}) => { channel.disabled = true; input.disabled = true; });
      show(text.sending);
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch('https://hub.normbitkisel.com/api/public/ticari-ileti-cikis/' + site, {
          method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body), signal: controller.signal
        });
        if (response.status === 429) { show(text.rate, true); return; }
        if (!response.ok) { show(text.retry, true); return; }
        const result = await response.json();
        if (result?.ok === true && result.status === 'received' && (result.iys === 'pending' || result.iys === 'unconfirmed')) {
          show(text.received);
        } else if (result?.ok === true && result.status === 'completed' && result.iys === 'completed') {
          show(text.completed);
        } else {
          show(text.retry, true);
          return;
        }
        fields.forEach(({channel, input}) => { channel.disabled = true; input.disabled = true; });
        form.dataset.consentReceived = 'true';
      } catch {
        show(text.retry, true);
      } finally {
        window.clearTimeout(timeout);
        button.disabled = form.dataset.consentReceived === 'true';
        if (!button.disabled) {
          channels.forEach((channel) => { channel.disabled = false; });
          sync();
        }
        button.removeAttribute('aria-busy');
      }
    });
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
